<script lang="ts" setup>
/* ... */
</script>

<template>
  <div class="scrollable-table-container">
    <table>
      <slot></slot>
    </table>
  </div>
</template>

<style lang="scss">
@import 'src/assets/scss/globals';

.scrollable-table-container {
  width: 100%;
  overflow: auto;

  table {
    font-size: clamp(0.7rem, 1.75vw, 1rem);
    line-height: 1.25em;
    white-space: nowrap;
    border-collapse: collapse;

    tbody tr:nth-child(odd) th,
    tbody tr:nth-child(odd) td {
      background-color: $color-background;
    }

    tbody tr:nth-child(even) th,
    tbody tr:nth-child(even) td {
      background-color: $color-background-disabled;
    }

    thead th,
    tbody th {
      position: sticky;
      left: 0;
    }

    thead th {
      top: 0;
      z-index: 1;
      background-color: $color-accent;
      color: $color-text-inverted;
    }

    thead th:not(.no-uppercase) {
      text-transform: uppercase;
    }

    thead th:first-child {
      z-index: 2;
    }

    tbody th {
      z-index: 1;
      font-weight: normal;
    }

    thead th,
    tbody th,
    tbody td {
      padding: 0.35em 0.5em;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .fixed,
    .fixed-2x,
    .fixed-3x {
      text-align: center;
      min-width: min-content;
    }

    .fixed {
      max-width: 2em;
    }

    .fixed-2x {
      max-width: 4em;
    }

    .fixed-3x {
      max-width: 6em;
    }
  }
}
</style>
